import React from 'react';
import { Navigate, RouteObject } from 'react-router-dom';
import { appRoutes } from '../../path';
import MyProfile from './MyProfile';
import Preferences from './Preferences';

const personalRoutes: RouteObject[] = [
  {
    path: appRoutes.settings.routePrefix,
    element: <Navigate replace={true} to={appRoutes.settings.myProfile} />,
  },
  {
    path: appRoutes.settings.myProfile,
    element: <MyProfile />,
  },
  {
    path: appRoutes.settings.preferences,
    element: <Preferences />,
  },
];

export default personalRoutes;
